<template>
<div class="main my">
  <!-- 用户权限管理 -->
  <form class="model-box clear bcw" @submit.prevent="checkForm" v-cloak>
    <van-row class="tac ptw">
      <van-col span="10" offset="7">
        <upload-file
            :id="'avatar'"
            :img="postForm.avatar"
            @callBackImgUrl="getIdCardUrl"></upload-file>
        <div class="mtn mbm fs1 c9">(证件照)</div>
      </van-col>
    </van-row>
    <van-cell-group>
      <van-field v-model="postForm.realName" label="员工姓名" clearable placeholder="请输入" />
      <van-field v-model="postForm.mobile" label="员工电话" clearable type="tel" placeholder="请输入" />      
    </van-cell-group>
    <van-cell-group class="quan-box">
      <h4>权限</h4>
      <van-checkbox-group class="bcw clear" v-model="postForm.auth">
        <van-checkbox class="checkbox" checked-color="#4b0" key="staff" name="staff">员工管理</van-checkbox>
        <van-checkbox class="checkbox" checked-color="#4b0" key="practiceCard" name="practiceCard">练球卡</van-checkbox>
        <van-checkbox class="checkbox" checked-color="#4b0" key="ptCourse" name="ptCourse">私教课</van-checkbox>
        <van-checkbox class="checkbox" checked-color="#4b0" key="monthCard" name="monthCard">包月课</van-checkbox>
        <van-checkbox class="checkbox" checked-color="#4b0" key="writeOff" name="writeOff">扫码核销</van-checkbox>
        <van-checkbox class="checkbox" checked-color="#4b0" key="coach" name="coach">教练管理</van-checkbox>
      </van-checkbox-group>
    </van-cell-group>
    <the-btnbar :loadSta="subSta"></the-btnbar>
  </form>
</div>
</template>
<script>
import Vue from 'vue';
import func from "@/assets/scripts/func";
import TheBtnbar from './components/TheBtnBar';
import UploadFile from '@/components/UploadFile';
import {
  Cell, CellGroup,Checkbox, CheckboxGroup,SwitchCell,Toast
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Checkbox).use(CheckboxGroup).use(SwitchCell).use(Toast);

export default {
  components: {
    TheBtnbar,UploadFile
  },
  data() {
    return {
      subSta:false, //提交时 按钮状态
      postForm:{
        userId:this.$route.query.userId,
        avatar:'',
        realName:'',
        mobile:'',
        auth:[]
      }
    }
  },
  created(){
    // 扫描到id 取用户信息
    let uid = this.$route.query.userId
    if(uid){
      let _this = this
      this.$http.post('user/get',{
        id:uid
      }).then(function(res){
        console.log(res)
        if(!res.data.code){
          let userInfo = res.data.value
          _this.postForm.avatar = userInfo.mediumAvatar
          _this.postForm.realName = userInfo.nickname
          _this.postForm.mobile = userInfo.mobile
        }else{
          // Toast(res.data.message)
        }
      })
    }
    
  },
  methods: {
    getIdCardUrl: function(url){
      // 证件照片
      this.postForm[url.name] = url.url;
    },
    validMobile:function(value){
      let reg=11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
      if (value && !reg.test(value)) {
        return false
      } else {
        return true
      }
    },
    checkForm: function(){
      // console.log(this.postForm)
      // if(!this.validMobile(this.postForm.mobile)){
      //   Toast.fail('手机号格式不正确'); return false;
      // }

      let _this = this
      let temp = JSON.parse(JSON.stringify(_this.postForm))
      temp.auth = JSON.stringify(temp.auth)

      _this.subSta = true
      // 提交表单
      _this.$http.post('club_staff/create',temp).then(function(res){
          if(res.data.code == 0){
            Toast.success({                
              message:'添加成功！',
              duration:1000 
            })
            setTimeout(function(){
              _this.$router.go(-1)
            }, 1000) 
          }else{
            Toast(res.data.message)
            _this.subSta = false
          }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.quan-box{
  padding:.1rem .15rem;
  &>h4{
    font-size: .14rem;
    padding-bottom: .1rem;
  }
  & .checkbox{
    float: left;
    width: 30%;
    margin-right: 1%;
    margin-bottom: .1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/manage/StaffAdd.vue